import { TransactionResult } from '../types/TransactionResult'
import api from './api'

const getTransaction = async (paymentPageId: string, transactionId: string): Promise<TransactionResult> => {
    return await api('/api/payment-page/transaction', { paymentPageId, transactionId }) as TransactionResult
}

export default getTransaction
